import * as swcHelpers from '@swc/helpers';
import { useMutation, Types } from '@grandvisionhq/graphql';
import '../operations/mutations/create-account.js';
import { SET_PASSWORD } from '../operations/mutations/create-password.js';

const mapConsents = (selectedConsents)=>selectedConsents.map((consent)=>({
            consentName: consent.value,
            literalText: consent.title,
            uiType: Types.UIType.CHECKBOX,
            value: true
        })
    )
;
var useSetPassword = ()=>{
    var ref;
    const [setPassword, { data , loading , error  }] = useMutation(SET_PASSWORD);
    const callback = (_param)=>{
        var { consents  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
            "consents"
        ]);
        return setPassword({
            variables: {
                input: swcHelpers.objectSpread({
                    consents: mapConsents(consents)
                }, rest)
            }
        });
    };
    return [
        callback,
        {
            customerId: data === null || data === void 0 ? void 0 : (ref = data.activateCustomerAccount) === null || ref === void 0 ? void 0 : ref.customerId,
            loading,
            error
        }, 
    ];
};

export { useSetPassword };
//# sourceMappingURL=use-create-password.js.map
